import Logger from '../Log'
import FillMethod from './FillMethod'
import { ecpmOrDefault, loadScript, playerDims } from '../utils'

const Log = Logger.for('UdmFillMethod')

export class UdmFillMethod extends FillMethod {
  constructor (bidder) {
    super('udm', bidder, 'display', ecpmOrDefault(bidder.params.ecpm, 0.5))
  }

  fill (slot, media) {
    const dims = playerDims(media, { })

    return new Promise((resolve, reject) => {
      const url = 'https://udmserve.net/udm/img.fetch?sid=' + this._bidder.params.sid + ';tid=1;dt=6;'
      loadScript(url, slot.node(), { 'data-cfasync': false }).then((script) => {
        slot.resource(script)

        setTimeout(() => {
          const qs = document.querySelectorAll('.udm-ad')
          if (qs.length) {
            // add actual udm-ad item to resource list since they dont fill within our
            // supplied div. this will ensure their ad is removed during our controlled refreshes
            slot.resource(qs[qs.length - 1]) // assume last entry belongs to us

            Log.info('UDM appears to have loaded')
            resolve({
              width: dims[0],
              height: dims[1],
              cpm: this.estValue()
            })
          } else {
            Log.warn('Doesnt look like UDM loaded')
            slot.resetNode()
            resolve({ cpm: 0 })
          }
        }, 1500)
      })
    })
  }
}
